import { render, staticRenderFns } from "./InspectionCard.vue?vue&type=template&id=493fa5f8&scoped=true&"
import script from "./InspectionCard.vue?vue&type=script&lang=js&"
export * from "./InspectionCard.vue?vue&type=script&lang=js&"
import style0 from "./InspectionCard.vue?vue&type=style&index=0&id=493fa5f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493fa5f8",
  null
  
)

export default component.exports